import { dateFormat } from '@/utils/dateFormat';
import {
  receiveStatusOptions,
  collectionStatusOptions,
  invoiceStatusOptions,
  executionStatusGroup,
} from '@/model/pickUpOrders';

const commonFormatter = (v) => {
  if (!v && v !== 0) {
    return '--';
  }
  return v;
};

function convertToName (enums, value) {
  let label = '--';

  for (let v of enums) {
    if (Number(v.value) === Number(value)) {
      label = v.label;
      break;
    }
  }

  return label;
}

function setExpandTbCols () {
  let commonCols = [
    {
      tooltip: true,
      title: '商品图片',
      width: 100,
      field: 'image',
      slots: {
        default: ({ row }, h) => {
          let previewLists = (row.image.split(',') || []).map(url => url.endsWith('.heic') ? `${url}?imageView2/2/w/800/h/800` : url) || [];
          const actions = previewLists && previewLists.length ? [
            <div class='cellContainer'>
              <el-image fit='cover' preview-src-list={previewLists} referrer-policy='unsafe-url' z-Index={0} style={'width:40px;height:40px;'} src={`${previewLists[0]}?imageView2/2/w/40/h/40`} ></el-image>
            </div>,
          ] : [<div>--</div>];
          return [h('div', actions)];
        },
      },
    },
    {
      tooltip: true,
      align: 'left',
      title: '商品编码（sku）',
      field: 'skuCode',
    },
    {
      tooltip: true,
      align: 'left',
      title: '商品名称',
      field: 'goodsName',
    },
    {
      tooltip: true,
      align: 'left',
      title: '规格',
      field: 'specification',
    },
    {
      tooltip: true,
      align: 'left',
      title: '型号',
      field: 'model',
    },
    {
      tooltip: true,
      align: 'left',
      title: '所属品牌',
      field: 'brandName',
    },
    {
      tooltip: true,
      align: 'left',
      title: '计量单位',
      field: 'unitName',
    },
    {
      tooltip: true,
      align: 'left',
      title: '销售数量',
      field: 'quantity',
    },
    {
      tooltip: true,
      align: 'left',
      title: '销售单价（含税）',
      field: 'taxPrice',
      formatter: ({ cellValue }) => {
        return cellValue === '' || cellValue === null || cellValue === undefined ? '--' : cellValue.toLocaleString('en-US', { minimumFractionDigits: 2 });
      },
    },
    {
      tooltip: true,
      align: 'left',
      title: '生产商',
      field: 'manufacturer',
    },
    {
      tooltip: true,
      align: 'left',
      title: '厂家编码',
      field: 'factoryCode',
    },
    {
      tooltip: true,
      align: 'left',
      title: '质保期',
      field: 'qualityAssPeriod',
      slots: {
        default: ({ row }) => {
          return `${row.qualityAssPeriod || ''}${row.qualityAssPeriodUnitName || ''}`;
        },
      },
    },
    {
      tooltip: true,
      align: 'left',
      title: '是否医疗件',
      field: 'medicalFlag',
      formatter: ({ cellValue }) => {
        return cellValue ? '是' : '否';
      },
    },
    {
      tooltip: true,
      align: 'left',
      title: '产品注册证/备案凭证',
      field: 'certificateNumber',
    },
  ];

  commonCols.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return commonCols;
}
// 订单列表配置
export function setOrderTableColumns (type = 0) {
  const orderTableColumns = [
    {
      type: 'expand',
      width: '50px',
      fixed: 'left',
      slots: {
        header: (_, h) => {
          let className = this.isExpand !== 3 ? 'allExpandIcon vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          let name = this.isExpand !== 3 ? 'vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          return [h('div', [<i name={name} class={className} style='cursor: pointer;font-size: 16px;' onClick={() => this.handleToggleExpand()}></i>])];
        },
        content: ({ row }, h) => {
          if (row.orderGoodsList?.length) {
            return [
              h('vxe-grid', {
                style: {
                  'z-index': 10,
                  'margin-left': '50px',
                  'margin-right': '100px',
                  'margin-top': '10px',
                  'margin-bottom': '10px',
                },
                props: {
                  align: 'center',
                  resizable: true,
                  stripe: false,
                  border: true,
                  autoResize: true,
                  showHeader: true,
                  showOverflow: true,
                  maxHeight: '500px',
                  size: 'mini',
                  data: row.orderGoodsList || [],
                  columns: setExpandTbCols(type, row, this),
                },
              }),
            ];
          }
        },
      },
    },
    {
      title: '订单编号',
      field: 'code',
      showOverflow: true,
      width: 140,
      tooltip: true,
    },
    {
      title: '商品信息',
      field: 'orderGoodsList',
      showOverflow: true,
      width: 240,
      tooltip: true,
      slots: {
        default: ({ row }) => {
          const goods = row.orderGoodsList.map(item => `${item.goodsName}_${item.model}_${item.quantity}${item.unitName}`).join(' / ');
          return goods;
        },
      },
    },
    {
      title: '发货状态',
      field: 'deliveryStatus',
      showOverflow: true,
      width: 100,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return convertToName(executionStatusGroup, cellValue);
      },
    },
    {
      title: '订单金额',
      field: 'totalAmount',
      showOverflow: true,
      width: 140,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue === '' || cellValue === null || cellValue === undefined ? '--' : cellValue.toLocaleString('en-US', { minimumFractionDigits: 2});
      },
    },
    {
      title: '订单数量',
      field: 'totalQuantity',
      showOverflow: true,
      width: 100,
      tooltip: true,
    },
    {
      title: '收货信息',
      field: 'receiverDetailAddress',
      showOverflow: true,
      width: 220,
      tooltip: true,
      slots: {
        default: ({ row }, h) => {
          return [
            h('div', {}, `${row.receiverName || ''}-${row.receiverPhone || ''}-${row.receiverProvinceName || ''}${row.receiverCityName || ''}${row.receiverAreaName || ''}${row.receiverDetailAddress || ''}`),
          ];
        },
      },
    },
    {
      title: '收货状态',
      field: 'receiveStatus',
      showOverflow: true,
      width: 120,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return convertToName(receiveStatusOptions, cellValue);
      },
    },
    {
      title: '客户抬头',
      field: 'customerName',
      showOverflow: true,
      width: 200,
      tooltip: true,
    },
    {
      title: '订单来源',
      field: 'sourceTypeDesc',
      showOverflow: true,
      width: 100,
      tooltip: true,
    },
    {
      title: '客户联系人',
      field: 'customerContactPhone',
      showOverflow: true,
      width: 180,
      tooltip: true,
      slots: {
        default: ({ row }) => {
          return `${row.customerContactName || ''} ${row.customerContactPhone || ''}`;
        },
      },
    },
    {
      title: '销售合同号',
      field: 'contractCode',
      showOverflow: true,
      width: 140,
      tooltip: true,
    },
    {
      title: '订单状态',
      field: 'statusDesc',
      showOverflow: true,
      width: 100,
      tooltip: true,
    },
    {
      title: '收款状态',
      field: 'collectionStatus',
      showOverflow: true,
      width: 100,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return convertToName(collectionStatusOptions, cellValue);
      },
    },
    {
      title: '开票状态',
      field: 'invoiceStatus',
      showOverflow: true,
      width: 100,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return convertToName(invoiceStatusOptions, cellValue);
      },
    },
    {
      title: '结算方式',
      field: 'settleWayDesc',
      showOverflow: true,
      width: 100,
      tooltip: true,
    },
    {
      title: '订单确认人',
      field: 'orderConfirmUserName',
      showOverflow: true,
      width: 100,
      tooltip: true,
    },
    {
      title: '对方单据号',
      field: 'outOrderCode',
      showOverflow: true,
      width: 140,
      tooltip: true,
    },
    {
      title: '更新时间',
      field: 'lastUpdateTime',
      showOverflow: true,
      width: 160,
      tooltip: true,
      formatter: ({ cellValue }) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '操作',
      fixed: 'right',
      showOverflow: false,
      width: '80px',
      slots: {
        default: ({ row }, h) => {
          let actions = [];
          actions.push(
            <span class='table-action' onClick={() => this.operate(row)}>查看</span>,
          );
          return [h('div', actions)];
        },
      },
    },
  ];

  orderTableColumns.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return orderTableColumns;
}
